import {useIntl} from 'react-intl'

type Unit = 'px' | '%'

type Props = {
  width?: string
  height?: string
  onChange: (next: {width: string; height: string}) => void
}

export function joinDisplaySize(value: string, unit: Unit): string {
  const amount = String(value || '').trim()
  const numeric = Number(amount)
  if (!amount || !Number.isFinite(numeric) || numeric <= 0) return ''
  return `${amount}${unit}`
}

export function splitDisplaySize(raw?: string): {value: string; unit: Unit} {
  const match = String(raw || '')
    .trim()
    .match(/^(\d+(?:\.\d+)?)(px|%)$/i)
  if (!match) return {value: '', unit: 'px'}
  return {value: match[1], unit: match[2].toLowerCase() as Unit}
}

const ImageDisplaySizeFields = ({width, height, onChange}: Props) => {
  const intl = useIntl()
  const parsedWidth = splitDisplaySize(width)
  const parsedHeight = splitDisplaySize(height)

  return (
    <div className='d-flex flex-column gap-3 mt-3'>
      <div>
        <label className='fw-bold fs-6 mb-2'>
          {intl.formatMessage({id: 'ADMIN.ATTRIBUTE.IMAGE_WIDTH'})}
        </label>
        <div className='d-flex gap-2'>
          <input
            type='number'
            min='0'
            step='1'
            className='form-control'
            value={parsedWidth.value}
            onChange={(event) =>
              onChange({
                width: joinDisplaySize(event.target.value, parsedWidth.unit),
                height: height || '',
              })
            }
            placeholder='400'
          />
          <select
            className='form-select'
            style={{maxWidth: 90}}
            value={parsedWidth.unit}
            onChange={(event) =>
              onChange({
                width: joinDisplaySize(parsedWidth.value, event.target.value as Unit),
                height: height || '',
              })
            }
          >
            <option value='px'>px</option>
            <option value='%'>%</option>
          </select>
        </div>
      </div>
      <div>
        <label className='fw-bold fs-6 mb-2'>
          {intl.formatMessage({id: 'ADMIN.ATTRIBUTE.IMAGE_HEIGHT'})}
        </label>
        <div className='d-flex gap-2'>
          <input
            type='number'
            min='0'
            step='1'
            className='form-control'
            value={parsedHeight.value}
            onChange={(event) =>
              onChange({
                width: width || '',
                height: joinDisplaySize(event.target.value, parsedHeight.unit),
              })
            }
            placeholder='auto'
          />
          <select
            className='form-select'
            style={{maxWidth: 90}}
            value={parsedHeight.unit}
            onChange={(event) =>
              onChange({
                width: width || '',
                height: joinDisplaySize(parsedHeight.value, event.target.value as Unit),
              })
            }
          >
            <option value='px'>px</option>
            <option value='%'>%</option>
          </select>
        </div>
      </div>
      <div className='form-text text-muted mt-0'>
        {intl.formatMessage({id: 'ADMIN.ATTRIBUTE.IMAGE_SIZE_HINT'})}
      </div>
    </div>
  )
}

export {ImageDisplaySizeFields}
